'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://msdn.microsoft.com/en-us/library/ms533052(v=vs.85).aspx

var LANGUAGES = [{ key: 'en', value: 'en', description: 'English' }, { key: 'ar', value: 'ar', description: 'Arabic' }, { key: 'bg', value: 'bg', description: 'Bulgarian' }, { key: 'ca', value: 'ca', description: 'Catalan' }, { key: 'de', value: 'de', description: 'German (Standard)' }, { key: 'el', value: 'el', description: 'Greek' }, { key: 'es', value: 'es', description: 'Spanish (Spain)' }, { key: 'fr-ca', value: 'fr-ca', description: 'French (Canada)' }, { key: 'fr', value: 'fr', description: 'French (Standard)' }, { key: 'he', value: 'he', description: 'Hebrew' }, { key: 'ja', value: 'ja', description: 'Japanese' }, { key: 'ko', value: 'ko', description: 'Korean' }, { key: 'pt-br', value: 'pt-br', description: 'Portuguese (Brazil)' }, { key: 'pt', value: 'pt', description: 'Portuguese (Portugal)' }, { key: 'zh-Hant', value: 'zh-Hant', description: 'Chinese (Traditional)' }, // ?
{ key: 'zh-Hans', value: 'zh-Hans', description: 'Chinese (Simplified)' }, // ?
{ key: 'pl-PL', value: 'pl-PL', description: 'Polish' }, // ?
{ key: 'ru', value: 'ru', description: 'Russian' }, { key: 'it', value: 'it', description: 'Italian (Standard)' }];

var DEFAULT = exports.DEFAULT = LANGUAGES[0];
exports.default = LANGUAGES;


//////////////////
// WEBPACK FOOTER
// ./src/constants/languages.js
// module id = 661
// module chunks = 0